//-----------------------------------
// index.js
// => theme/templates/index.liquid
//-----------------------------------

import $ from 'jquery';
// import '../../vendor/instafetch.js'
// Sections 
import { Sections } from '../sections/sections'
import { SlideshowSection } from '../sections/slideshow'

/*global
instafetch

*/

// DOM References
//-----------------------------------

// Sections
let $slideshow = $('[data-section-type="slideshow-section"]')


// Index Module
// ---------------------------------------
export let index = {

  init() {

    // $('#instafetch').hide();
    index.sections();

  //   $(window).bind("load", function() {
  //    instafetch.init({
  //     accessToken: '2159737229.c8e7e3a.aa3ab99a07534fcd83c9c092860e806e',
  //     target: 'instafetch',
  //     numOfPics: 4,
  //     caption: false 
  //   });
  //   $('#instafetch').fadeIn();

    
  // });
    
    
  },

  sections() {
    let sections = new Sections();

    // Sections that require special initialization
    if( $slideshow.length ){
      sections.register('slideshow-section', SlideshowSection);
    }

  }
 
  

}







